import tippy, { roundArrow } from 'tippy.js'

tippy.setDefaultProps({
  arrow: roundArrow,
  theme: 'kolide',
})
